import { Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
    savemsg,
    saveWarningMsg,
    serverMsg
} from "../../config/messageconstant";
import { getSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadExcel, downloadF } from "../PDF/PDFDownload";
import BeatAssignOrUnassignTable from "./BeatAssignOrUnassignTable";
import ImportPopUp from "./ImportPopUp";

// import NewBeatCreationImportPopUp from "./NewBeatCreationImportPopUp";
const ExcelJS = require("exceljs");

class BeatAssignOrUnassignMain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            salesTeam: "",
            searchValue: "",
            importPopUpFlag: false,
            validatedProductList: [],
            hasErrorRow: false,
        };


    }

    onClickOfExport = async () => {
        const { showLoador, showNotification } = this.props;

        showLoador({ loador: true });
        await downloadF({
            isGet: true,
            url: endpoint.exportData + "/get-beat-assign-data-excel",
            ext: "xls",
            openNewTab: false,
            isShowSalesPersonName: true,
            reportName: "Beat Assign/Unassign CSV",
        }).then((response) => {
            if (!response) {
                showNotification({
                    msg: serverMsg,
                    severity: "error",
                });
            } else {
                showNotification({
                    msg: "Excel Exported Successfully",
                });
            }
        });
        showLoador({ loador: false });
    };

    onClickOfImport = () => {
        this.setState({ importPopUpFlag: true });
    };

    onSearchBox = (e) => {
        this.setState({
            searchValue: e.target.value,
        });
    };

    getFilteredTableData = (searchData) => {
        const { searchValue } = this.state;
        return searchData.filter((currentRow) => {
            let isValid = false;

            let employeeCode = currentRow?.employeeCode;
            let townName = currentRow?.townName;
            let beatName = currentRow?.beatName;
            let removeAssignationFlag = currentRow?.removeAssignationFlag == 1 ? "Yes" : "No";
            let isSelfAssign = currentRow?.isSelfAssign == 1 ? "Yes" : "No";
            let dailyAllowance = currentRow?.dailyAllowance;
            let ratePerKm = currentRow?.ratePerKm;
            let beatType = currentRow?.beatType == 0 ? "Local" : "Out Station";


            if (
                (employeeCode &&
                    employeeCode
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (townName &&
                    townName
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (beatName &&
                    beatName
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (removeAssignationFlag &&
                    removeAssignationFlag
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (isSelfAssign &&
                    isSelfAssign
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (dailyAllowance &&
                    dailyAllowance
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (ratePerKm &&
                    ratePerKm
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (beatType &&
                    beatType
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
        });
    };

    onSubmit = () => {
        const { showLoador, showNotification } = this.props;
        const { validatedProductList } = this.state;

        let dataToSendList =
            validatedProductList.length !== 0 ? validatedProductList : [];

        swal({
            title: "Are you sure?",
            text: saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                await apiPost({
                    url: endpoint.importData + "/save-validated-beat-assign-data",
                    postBody: dataToSendList,
                }).then(({ data, success }) => {
                    if (!success) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    } else {
                        showNotification({
                            msg: savemsg,
                        });

                        setTimeout(() => {
                            window.location.reload();
                        }, 1250);
                    }
                });
                showLoador({ loador: false });

            }
        });
    };

    importPopUpClose = () => {
        this.setState({ importPopUpFlag: false });
    };

    dataMethod = (dataObj) => {
        const hasErrorRow = dataObj.some((item) => item.flag == 1);

        this.setState({ validatedProductList: dataObj, hasErrorRow });
    };

    render() {
        const {
            importPopUpFlag,
            validatedProductList,
            hasErrorRow,
            searchValue,
        } = this.state;

        return (
            <>
                <Paper
                    sx={{
                        borderRadius: 2,
                        p: { xs: 2, sm: 4 },
                        boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
                        // background: "linear-gradient(135deg,rgb(251, 251, 251) 0%,rgb(238, 247, 250) 100%)",
                        maxWidth: "auto",
                        margin: "auto",
                    }}
                    elevation={5}
                >

                    <BeatAssignOrUnassignTable
                        onClickOfExport={this.onClickOfExport}
                        onClickOfImport={this.onClickOfImport}
                        searchValue={searchValue}
                        onSearchBox={this.onSearchBox}
                        validatedProductList={validatedProductList}
                        getFilteredTableData={this.getFilteredTableData}

                    />

                    {validatedProductList.length !== 0 && !hasErrorRow && (
                        <>
                            <Grid
                                item
                                sm={12}
                                xs={12}
                                md={12}
                                lg={12}
                                rowSpacing={2}
                                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                                container
                                justifyContent="right"
                                sx={{ marginTop: 3 }}
                            >
                                <ButtonCompo
                                    size="medium"
                                    type="submit"
                                    variant="contained"
                                    name="Submit"
                                    onClick={this.onSubmit}
                                />
                            </Grid>
                        </>
                    )}
                </Paper>


                {importPopUpFlag && (
                    <ImportPopUp
                        open={importPopUpFlag}
                        handleCloses={this.importPopUpClose}
                        dataMethod={this.dataMethod}
                    />
                )}
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    salesPersonList: state.salesExecutive,
});

const mapDispatchToProps = {
    showLoador,
    showNotification,
    downloadExcel,
    getSalesExecutiveByUserType,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(BeatAssignOrUnassignMain);
